import { defineMessages } from 'react-intl';

export default defineMessages({
  toolsForProject: {
    id: 'toolsForProject',
    defaultMessage: 'Tools for your next project'
  },
  customizedProducts: {
    id: 'customizedProducts',
    defaultMessage: 'Looking for customized or gene-specific products?'
  },
  seeYourProducts: {
    id: 'seeYourProducts',
    defaultMessage: 'See your GeneArt® products'
  },
  customProductsLines: {
    id: 'customProductsLines',
    defaultMessage: 'Learn more about our custom product lines'
  }
});
